export default __webpack_public_path__ + "static/media/mobile.ee88ff9d.svg";